<ng-container ngForm #frm="ngForm">
	<mat-label *ngIf="label" [ngClass]="labelClass">{{ label }}<span *ngIf="required"> * </span></mat-label>
	<mat-form-field
		[ngClass]="inputClass"
		[appearance]="appearance"
		[style.user-select]="disabled ? 'none' : null"
		[style.cursor]="disabled ? 'not-allowed' : null"
	>
		<ng-container *ngIf="fieldType !== 'textarea' && dataType === 'number'">
			<input
				#control
				matInput
				type="number"
				autocomplete="{{ disableAutocomplete ? 'new-password' : 'off' }}"
				[id]="id"
				[placeholder]="placeholder + (placeholder !== '' && required ? '*' : '')"
				[appCustomPatternValidator]="fieldValidationConstraints"
				[disabled]="disabled"
				[(ngModel)]="result"
				[tabIndex]="tabIndex"
				(ngModelChange)="onModelChanged($event)"
				(blur)="onBlur($event)"
				appRestrict
				[restrict]="restrict"
				[maxlength]="maxlength"
				(keyup.enter)="onEnter()"
				(keydown.enter)="onEnterKeyDown()"
				[name]="name"
				[readonly]="readonly"
				[style.cursor]="disabled ? 'not-allowed' : null"
				[style.caret-color]="disabled ? 'transparent' : null"
			/>
		</ng-container>
		<ng-container *ngIf="fieldType !== 'textarea' && dataType !== 'number'">
			<input
				#control
				matInput
				autocomplete="{{ disableAutocomplete ? 'new-password' : 'off' }}"
				[id]="id"
				[type]="dataType"
				[placeholder]="placeholder + (placeholder !== '' && required ? '*' : '')"
				[appCustomPatternValidator]="fieldValidationConstraints"
				[disabled]="disabled"
				[(ngModel)]="result"
				[tabIndex]="tabIndex"
				(ngModelChange)="onModelChanged($event)"
				(blur)="onBlur($event)"
				appRestrict
				[restrict]="restrict"
				[maxlength]="maxlength"
				(keyup.enter)="onEnter()"
				(keydown.enter)="onEnterKeyDown()"
				[name]="name"
				[readonly]="readonly"
				[style.cursor]="disabled ? 'not-allowed' : null"
				[style.caret-color]="disabled ? 'transparent' : null"
			/>
		</ng-container>
		<ng-container *ngIf="fieldType === 'textarea'">
			<textarea
				#control
				matInput
				[id]="id"
				[type]="dataType"
				[placeholder]="placeholder + (placeholder !== '' && required ? '*' : '')"
				[appCustomPatternValidator]="fieldValidationConstraints"
				[disabled]="disabled"
				[(ngModel)]="result"
				[tabIndex]="tabIndex"
				(ngModelChange)="onModelChanged($event)"
				(blur)="onBlur($event)"
				appRestrict
				[restrict]="restrict"
				[maxlength]="maxlength"
				(keyup.enter)="onEnter()"
				(keydown.enter)="onEnterKeyDown()"
				[name]="name"
				[readonly]="readonly"
				cdkTextareaAutosize
				[cdkAutosizeMinRows]="rows"
				[cdkAutosizeMaxRows]="maxRows"
				[style.cursor]="disabled ? 'not-allowed' : null"
				[style.caret-color]="disabled ? 'transparent' : null"
			></textarea>
		</ng-container>
		<mat-hint *ngIf="hint">{{ hint }}</mat-hint>

		<button
			mat-icon-button
			matSuffix
			disableRipple
			type="button"
			class="visibility-toggle"
			*ngIf="showVisibilityToggle"
			(click)="toggleVisibility($event)"
		>
			<mat-icon>{{ dataType === 'password' ? 'visibility' : 'visibility_off' }}</mat-icon>
		</button>

		<mat-error>
			<ws-field-error
				[error]="error"
				[interpolationParams]="errorInterpolationParams"
				[control]="frm.controls[name]"
			></ws-field-error>
		</mat-error>
	</mat-form-field>
	<span *ngIf="unit">{{ unit }}</span>
</ng-container>
